var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroup = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14.917,
    viewBox: "0 0 18 14.917",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.323,7.874A3.316,3.316,0,1,0,3.008,4.559,3.316,3.316,0,0,0,6.323,7.874Zm0-5.511a2.2,2.2,0,1,1-2.2,2.2,2.2,2.2,0,0,1,2.2-2.2Z",
    transform: "translate(0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2,5.172a2.586,2.586,0,1,0-2.586-2.586A2.586,2.586,0,0,0,13.2,5.172Zm0-4.052a1.466,1.466,0,1,1-1.466,1.466A1.466,1.466,0,0,1,13.2,1.12Z",
    transform: "translate(0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2,5.765A4.776,4.776,0,0,0,8.659,9.046,6.312,6.312,0,0,0,0,14.917H1.12a5.2,5.2,0,1,1,10.408,0h1.12A6.319,6.319,0,0,0,9.676,9.565a3.67,3.67,0,0,1,7.2,1H18a4.8,4.8,0,0,0-4.8-4.8Z",
    transform: "translate(0)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroup);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/group.1e24b1d757a415e47f95126e6698bba9.svg";